// A name that opens where an agent stands on a project in the agent pane: the specialist
// on a next action, the agent at the head of an answer.
// See docs/Y2026-Q4/design-agent-peek.md.
import type { ReactNode } from "react";

import { useAgentSlot } from "../api/agentSlot";
import { useAgentPane } from "../state/useAgentPane";
import { agentDisplayLabel } from "../utils/runParticipants";
import styles from "./PeekButton.module.css";

export const PeekButton = ({
  projectId,
  agent,
  look,
  children,
}: {
  projectId: string;
  agent: string;
  look: "link" | "chip";
  children: ReactNode;
}) => {
  const pane = useAgentPane();
  const config = useAgentSlot();
  return (
    <button
      type="button"
      className={`${styles.peek} ${styles[look]}`}
      title={`See where ${agentDisplayLabel(agent)} stands on this project`}
      onClick={(e) => {
        // Inside a row that opens on click: the peek opens instead.
        e.stopPropagation();
        pane.peek({ projectId, config, agent });
      }}
    >
      {children}
    </button>
  );
};
